const transition = {
    duration: 1.2,
    ease: [0.6, 0.01, -0.05, 0.95],
};

export default transition;
